module.exports = "<app-menu></app-menu>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main